/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cal': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 8)" _stroke="#00272E"><rect pid="0" x=".333" y="1.667" width="15.333" height="14" rx=".68"/><path pid="1" d="M3.667.334v3.333"/><path pid="2" d="M12.333.334v3.333"/><path pid="3" d="M.333 5h15.334"/><path pid="4" d="M8 5v10.667"/><path pid="5" d="M4 5v10.667"/><path pid="6" d="M12 5v10.667"/><path pid="7" d="M.333 10.334h15.334"/><path pid="8" d="M.333 7.667h15.334"/><path pid="9" d="M.333 13h15.334"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/cal.js